import { render, staticRenderFns } from "./dept3-tab.vue?vue&type=template&id=4cb8d83b&scoped=true"
import script from "./dept3-tab.vue?vue&type=script&lang=js"
export * from "./dept3-tab.vue?vue&type=script&lang=js"
import style0 from "./dept3-tab.vue?vue&type=style&index=0&id=4cb8d83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8d83b",
  null
  
)

export default component.exports